import type {RouteRecordRaw} from "vue-router";
import router from "@/router/index";

export default [
    {
        path: "/",
        name: "/",
        redirect: "/login",
    },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("@/views/HomeView.vue")
    },
    {
        path: "/dashboard/statistic/itemShop",
        name: "ItemShop Statistic",
        component: () => import("@/views/statistic/ItemShopView.vue")
    },
    {
        path: "/dashboard/statistic/live",
        name: "Live Statistics",
        component: () => import("@/views/statistic/LiveStatisticsView.vue")
    },
    {
        path: "/dashboard/statistic/players",
        name: "Players Statistic",
        component: () => import("@/views/statistic/PlayersStatisticView.vue")
    },
    {
        path: "/dashboard/tickets/bugs",
        name: "Ticket Bugs",
        component: () => import("@/views/tickets/BugsView.vue")
    },
    {
        path: "/dashboard/tickets/reports",
        name: "Ticket Reports",
        component: () => import("@/views/tickets/ReportsView.vue")
    },
    {
        path: "/dashboard/chat/management",
        name: "Chat Management",
        component: () => import("@/views/chat/ManagementView.vue")
    },
    {
        path: "/dashboard/permissions/users",
        name: "Permission Users",
        component: () => import("@/views/permissions/UsersView.vue")
    },
    {
        path: "/dashboard/permissions/roles",
        name: "Permission Roles",
        component: () => import("@/views/permissions/RolesView.vue")
    },
    {
        path: "/dashboard/chat/banned-words",
        name: "Banned Words",
        component: () => import("@/views/chat/ManagementView.vue")
    },
    {
        path: "/dashboard/users",
        name: "Users",
        component: () => import("@/views/players/PlayersView.vue")
    },
    {
        path: "/dashboard/entity-map/players",
        name: "Players",
        component: () => import("@/views/entityMap/PlayersView.vue")
    },
    {
        path: "/dashboard/entity-map/spawners",
        name: "Spawners",
        component: () => import("@/views/entityMap/SpawnersView.vue")
    },
    {
        path: "/dashboard/entity-map/npcs",
        name: "NPCs",
        component: () => import("@/views/entityMap/NpcsView.vue")
    },
    /*    {
            path: "/dashboard/entity-map/teleports",
            name: "Teleports",
            component: () => import("@/views/entityMap/TeleportsView.vue")
        },*/
    {
        path: "/dashboard/quests/side-quests",
        name: "Side Quests",
        component: () => import("@/views/quests/SideView.vue")
    },
    {
        path: "/dashboard/quests/categories",
        name: "Quests Categories",
        component: () => import("@/views/quests/CategoriesView.vue")
    },
    {
        path: "/dashboard/quests/mappings",
        name: "Quests Mapping",
        component: () => import("@/views/quests/MappingView.vue")
    },
    {
        path: "/dashboard/game-content/cases-packs",
        name: "Cases & Packs",
        component: () => import("@/views/gameContent/CasesPackView.vue")
    },
    {
        path: "/dashboard/game-content/entities",
        name: "Entities",
        component: () => import("@/views/gameContent/EntitiesView.vue")
    },
    {
        path: "/dashboard/game-content/equipment",
        name: "Equipment",
        component: () => import("@/views/gameContent/EquipmentView.vue")
    },
    {
        path: "/dashboard/game-content/items",
        name: "Item Prototypes",
        component: () => import("@/views/gameContent/ItemPrototypesView.vue")
    },
    {
        path: "/dashboard/game-content/game-items",
        name: "Item Presets",
        component: () => import("@/views/gameContent/GameItemsView.vue")
    },
    {
        path: "/dashboard/game-content/itemshop",
        name: "Item Shop",
        component: () => import("@/views/gameContent/itemshop/ItemShopView.vue")
    },
    {
        path: "/dashboard/game-content/archon-packs",
        name: "Archon Packs",
        component: () => import("@/views/gameContent/itemshop/ArchonPacksView.vue")
    },
    {
        path: "/dashboard/game-content/itemshop-layout",
        name: "ItemShop Layout",
        component: () => import("@/views/gameContent/itemshop/ItemShopLayoutView.vue")
    },
    {
        path: "/dashboard/game-content/cosmetics",
        name: "Cosmetics",
        component: () => import("@/views/gameContent/CosmeticsView.vue")
    },
    {
        path: "/dashboard/game-content/vouchers",
        name: "Vouchers",
        component: () => import("@/views/gameContent/VoucherView.vue")
    },
    {
        path: "/dashboard/server-control",
        name: "Server Control",
        component: () => import("@/views/serverControl/ServerControlView.vue")
    },
    {
        path: "/dashboard/translations/static-translations",
        name: "Static Translations",
        component: () => import("@/views/translations/StaticTranslationsView.vue")
    },
    {
        path: "/dashboard/translations/dynamic-translations",
        name: "Dynamic Translations",
        component: () => import("@/views/translations/DynamicTranslationsView.vue")
    },
    {
        path: "/dashboard/wiki/about-game",
        name: "About Game",
        component: () => import("@/views/wiki/WikiView.vue")
    },
    {
        path: "/dashboard/wiki/game-lore",
        name: "Game Lore",
        component: () => import("@/views/wiki/WikiView.vue")
    },
    {
        path: "/dashboard/wiki/current-issues",
        name: "Current Issues",
        component: () => import("@/views/wiki/WikiView.vue")
    },
    {
        path: "/dashboard/wiki/coming-soon",
        name: "Coming Soon",
        component: () => import("@/views/wiki/WikiView.vue")
    },
    {
        path: "/dashboard/wiki/changelog",
        name: "Changelog",
        component: () => import("@/views/wiki/WikiView.vue")
    },
    {
        path: "/dashboard/settings/properties",
        name: "Properties",
        component: () => import("@/views/settings/PropertiesView.vue")
    },
    {
        path: "/dashboard/settings/vocations",
        name: "Vocations",
        component: () => import("@/views/settings/VocationsView.vue")
    },
    {
        path: "/dashboard/settings/network-infrastructure",
        name: "Network Infrastructure",
        component: () => import("@/views/settings/NetworkView.vue")
    },
    {
        path: "/dashboard/settings/npc-shared-knowledge",
        name: "NPC Shared Knowledge",
        component: () => import("@/views/settings/NpcSharedKnowledgeView.vue")
    },
    {
        path: "/dashboard/settings/ai-tokens-limits",
        name: "AI Tokens Limits",
        component: () => import("@/views/settings/AITokensLimitsView.vue")
    },
    {
        path: "/dashboard/settings/skills",
        name: "Skills",
        component: () => import("@/views/settings/SkillsView.vue")
    },
    {
        path: "/dashboard/settings/conversation-timeouts",
        name: "Conversation Timeouts",
        component: () => import("@/views/settings/ConvoTimeoutsView.vue")
    },
    {
        path: "/dashboard/settings/server-access",
        name: "Server Access",
        component: () => import("@/views/settings/ServerAccessView.vue")
    },
    {
        path: "/dashboard/settings/influ-server-access",
        name: "Influ Server Access",
        component: () => import("@/views/settings/InfluServerAccessView.vue")
    },
    {
        path: "/dashboard/settings/attacks",
        name: "Attacks",
        component: () => import("@/views/settings/AttacksView.vue")
    },
    {
        path: "/dashboard/settings/spiritual-guide",
        name: "Spiritual Guide",
        component: () => import("@/views/settings/SpiritualGuideView.vue")
    },
    {
        path: "/dashboard/discord/messages",
        name: "Discord Messages",
        component: () => import("@/views/discord/MessagesView.vue")
    },
    {
        path: "/dashboard/steam/post-translator",
        name: "Post Translator",
        component: () => import("@/views/steam/PostTranslatorView.vue")
    },
    {
        path: '/icons',
        name: 'Icons',
        component: () => import('@/views/utility/IconsView.vue'),
        beforeEnter: async (to, from, next) => {
            if (import.meta.env.VITE_APP_ENV === 'main') {
                next();
            } else {
                await router.push("/error-404");
            }
        },
    },
    {
        path: '/login',
        name: "Login",
        component: () => import('@/views/account/LoginView.vue')
    },
    {
        path: '/maintenance',
        name: "maintenance",
        component: () => import('@/views/utility/MaintenanceView.vue'),
    },
    {
        path: '/mobile',
        name: 'Mobile',
        component: () => import('@/views/utility/MobileView.vue')
    },
    {
        path: '/error-404',
        name: 'Error-404',
        component: () => import('@/views/utility/ErrorView.vue')
    },
    {
        path: "/:catchAll(.*)",
        name: 'error-404',
        redirect: '/error-404',
    }
 ] satisfies RouteRecordRaw[];
